import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const SameCardLinkedModal = (props) => {
    const messages = usePageMessages();

    return (
        <ModalComponent canCloseModal={false}>
            <InfoPage
                iconName="card-alert-80"
                iconColor="primary"
                insideModalComponent={true}
                headerText={messages.yourCardIsLinkedToAnotherAccount}
                secondaryText={messages.pleaseContactUs}
                primaryButtonCaption={messages.chatButton}
                primaryButtonType="link"
                primaryButtonDataTestId="same-card-linked-chat-button"
                primaryButtonOnClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
                topButtonCaption={messages.notNowButton}
                topButtonType="link"
                topButtonDataTestId="same-card-linked-not-now-button"
                topButtonOnClick={(e) => {
                    e.preventDefault();
                    props.modalRef.current.close();
                }}
                dataTestId="same-card-linked-screen"
            />
        </ModalComponent>
    );
};

export default connect(null, { toggleChat })(SameCardLinkedModal);
